
const tokenKey = 'Authorization'

export function getToken() {
  return localStorage.getItem(tokenKey)
}

export function setToken(token) {
  return localStorage.setItem(tokenKey, token)
}

export function removeToken() {
  return localStorage.removeItem(tokenKey)
}
const userInfoKey = 'userInfo'
export function getUserInfo() {
  return localStorage.getItem(userInfoKey)
}

export function setUserInfo(userInfo) {
  return localStorage.setItem(userInfoKey, userInfo)
}

export function removeUserInfo() {
  return localStorage.removeItem(userInfoKey)
}
